<template>
  <div class="updateFrame">
   <main class="t-main">
     <ol class="m-breadcrumb">
       <li class="m-breadcrumb__item"><router-link class="a-text a-link" to="/delivery/list-frame">枠一覧</router-link></li>
       <li class="m-breadcrumb__item"><router-link class="a-text a-link" v-bind:to="{ path: 'get-frame', query: { fqdn: this.$route.query.fqdn, frameId: this.$route.query.frameId}}">枠詳細</router-link></li>
       <li class="m-breadcrumb__item"><span class="a-text">枠編集</span></li>
     </ol>
     <h1 class="a-title">{{ updateFrameTitle }}</h1>
     <div class="m-form__item-wrapper">
       <h2 class="a-title a-title--sub">frameId</h2>
       <div class="m-form__item m-form__item--50">
         <label class="m-form__label">frameIdを入力してください<span class="m-form__label--necessary">※必須</span>
           <h2 class="a-title a-title--sub" style="margin-bottom: 0px;">{{tasks.frameId}}</h2>
         </label>
       </div>
     </div>
     <br/><hr/><br/>
     <div class="m-form__item-wrapper">
       <h2 class="a-title a-title--sub">タイトル</h2>
       <div class="m-form__item m-form__item--50">
         <label class="m-form__label">タイトルを入力してください<span class="m-form__label--necessary">※必須</span>
           <input class="m-form__input m-form__input--text" type="text" placeholder="例：test" v-model="tasks.metadata.name">
         </label>
       </div>
     </div>
     <br/><hr/><br/>
     <h2 class="a-title a-title--sub">表示（非表示）ページ</h2>
     <div class="m-form__item-wrapper"　v-for="list in tasks.configuration.pages">
       <div class="m-form__item m-form__item m-form__item--50">
         <label class="m-form__label">ドメイン下のパスを正規表現で指定できます<span class="m-form__label--necessary">※必須</span>
           <input class="m-form__input m-form__input--text" type="text" placeholder="例：/contents/*" v-model="list.pattern">
         </label>
       </div>
       <div class="m-form__item m-form__item--30">
         <label class="m-form__label">mode（表示・非表示）<span class="m-form__label--necessary">※必須</span><span class="m-form__input--select-wrapper">
             <select class="m-form__input m-form__input--select" name="category" v-model="list.mode" >
               <option value="" disabled>--選択してください--</option>
               <option v-for="(val, key) in pageMode" v-bind:value="key">{{ val }}</option>
             </select></span></label>
       </div>
       <button class="m-form__delete" v-on:click="deletePage(list)">delete</button>
     </div>
     <p class="a-button__wrapper"><button class="a-button a-button--danger" v-on:click="createPage">表示（非表示）ページを追加する</button></p>
     <br/><hr/><br/>
     <div class="m-form__item-wrapper">
       <h2 class="a-title a-title--sub m-form__item--30">セグメント</h2>
       <div class="m-form__item m-form__item--50" v-if="tasks.configuration.segments==''">
         <label class="m-form__label">セグメント登録<span class="m-form__input--select-wrapper">
             <select class="m-form__input m-form__input--select" name="category" v-model="segment" @change="addSegmentThing(segment)">
               <option value="" disabled>--選択してください--</option>
               <option v-for="Segment in segmentList" v-bind:value="Segment.segmentId">{{ Segment.metadata.name }}</option>
             </select>
         </span></label>
       </div>
       <label v-if="tasks.configuration.segments!=''" class="m-form__label">セグメントを空にすると、指定セグメントの変更ができます
         <h2 class="a-title a-title--sub m-form__item--30">{{tasks.configuration.segments[0].segmentId}}</h2>
       </label>
       <button class="m-form__delete" v-on:click="deleteSegment(tasks.configuration.segments[0])">delete</button>
     </div>
     <br/><hr/><br/>
     <div class="m-form__item-wrapper">
       <h2 class="a-title a-title--sub m-form__item--30">アクション種別</h2>
       <label class="m-form__label">
         <h2 class="a-title a-title--sub">{{actionType}}</h2>
       </label>
     </div>
     <h2 class="a-title a-title--sub">アクション設定</h2>
     <div class="m-form__item-wrapper" v-for="list in tasks.configuration.actions">
       <h2 class="a-title a-title--sub m-form__item--30">{{actionNames[list.actionId]}}</h2>
       <div class="m-form__item m-form__item--20">
         <label class="m-form__label">出現率<span class="m-form__label--necessary">※必須</span>
           <input class="m-form__input m-form__input--text" type="number" step="1" max="100" min="1" placeholder="パーセント" v-model="list.ratio" @change="ratioChange()">
         </label>
       </div>
       <button class="m-form__delete" v-on:click="deleteAction(list)">delete</button>
     </div>
     <div class="m-form__item-wrapper">
       <h2 class="a-title a-title--sub m-form__item--50">アクションを実行しない比率　{{ nonRatio }}</h2>
     </div>
     <div class="m-form__item-wrapper">
       <h2 class="a-title a-title--sub m-form__item--30">右タブからアクションを追加できます</h2>
       <div class="m-form__item m-form__item--30">
         <select class="m-form__input m-form__input--select m-form__item--20" name="category" v-model="addAction" @change="addActionThing(addAction)">
           <option value="" disabled>--選択してください--</option>
           <option v-for="action in actionList" v-bind:value="action.actionId">{{ action.metadata.name }}</option>
         </select></span></label>
       </div>
     </div>
     <br/><hr/><br/>
     <h2 class="a-title a-title--sub">ルール</h2>
     <div v-for="list in tasks.configuration.rules">
     <div class="m-form__item-wrapper"　>
       <label class="m-form__label m-form__item--100" >{{rulememoList[list.type]}}
           <h2 class="a-title a-title--sub m-form__item--100" >{{ruleList[list.type]}}</h2>
       </label>
     </div>
     <div class="m-form__item-wrapper"　>
       <div class="m-form__item" v-for="(val, key) in list">
         <label
          class="m-form__label m-form__item--100"
          v-if="key!='type' && (key=='count' || key=='threashold' || key=='seconds'|| key=='interval')"
         >{{jpList[key]}}<span class="m-form__label--necessary">※必須</span>
           <input
            class="m-form__input m-form__input--text"
            type="number" min="1"
            v-model=list[key]
           >
         </label>
         <label
          class="m-form__label m-form__item--100"
          v-if="key!='type' && key=='operator' && (list.type=='visit-count' || list.type=='last-page-view' || list.type=='page-view-count' || list.type=='stay-seconds' || list.type=='view-page-path')"
         >{{jpList[key]}}<span class="m-form__label--necessary">※必須</span>
           <select
            class="m-form__input m-form__input--select"
            name="category"
            v-model=list[key]
           >
             <option value="" disabled>--選択してください--</option>
             <option v-for="operator in operatorList" v-bind:value="operator">{{ jpList[operator] }}</option>
           </select>
         </label>
         <label
          class="m-form__label m-form__item--100"
          v-if="key!='type' && key=='operator' && list.type!='visit-count' && list.type!='last-page-view' && list.type!='page-view-count' && list.type!='stay-seconds' && list.type!='view-page-path'"
         >{{jpList[key]}}<span class="m-form__label--necessary">※必須</span>
           <select
            class="m-form__input m-form__input--select"
            name="category"
            v-model=list[key]
           >
             <option value="" disabled>--選択してください--</option>
             <option v-for="operator in strOperatorList" v-bind:value="operator">{{ jpList[operator] }}</option>
           </select>
         </label>
         <label
          class="m-form__label m-form__item--100"
          v-if="key!='type' && key=='scope'"
         >{{jpList[key]}}<span class="m-form__label--necessary">※必須</span>
           <select class="m-form__input m-form__input--select" name="category" v-model=list[key] >
             <option value="" disabled>--選択してください--</option>
             <option v-for="scope in scopeList" v-bind:value="scope">{{ jpList[scope] }}</option>
           </select>
         </label>
         <label
          class="m-form__label m-form__item--100"
          v-if="key!='type' && list.type=='referer' && key=='page'"
         >リファラ（ドメイン）<span class="m-form__label--necessary">※必須</span>
           <input
            class="m-form__input m-form__input--text"
            type="text" placeholder=""
            v-model=list[key]
           >
         </label>
         <label
          class="m-form__label m-form__item--100"
          v-if="key!='type' && list.type=='user-os' && key=='value'"
         >OS名<span class="m-form__label--necessary">※必須</span>
           <input
            class="m-form__input m-form__input--text"
            type="text" placeholder=""
            v-model=list[key]
           >
         </label>
         <label
          class="m-form__label m-form__item--100"
          v-if="key!='type' && list.type!='referer' && list.type!='user-os' && (key=='page' || key=='page1' || key=='page2' || key=='page3' || key=='value' || key=='values' || key=='link')"
         >{{jpList[key]}}<span class="m-form__label--necessary">※必須</span>
           <input
            class="m-form__input m-form__input--text"
            type="text" placeholder=""
            v-model=list[key]
           >
         </label>
         <label class="m-form__label m-form__item--100" v-if="key=='timezone'">
            {{jpList[key]}}<span class="m-form__label--necessary">※必須</span>
            <select class="m-form__input m-form__input--select" name="category" v-model="list[key]" >
            <option value="" disabled>--選択してください--</option>
              <option v-for="(val, key) in timezoneList" v-bind:value="key">{{ val }}</option>
            </select></span>
         </label>
         <label class="m-form__label m-form__item--100" v-if="key=='periodType'">
            {{jpList[key]}}<span class="m-form__label--necessary">※必須</span>
            <select class="m-form__input m-form__input--select" name="category" v-model="list[key]" >
            <option value="" disabled>--選択してください--</option>
              <option v-for="val in periodTypeList" v-bind:value="val">{{ jpList[val] }}</option>
            </select></span>
         </label>

         <label class="m-form__label m-form__item--100" v-if="key=='dayOfWeekThreshold' && list.periodType == 'week'">
            {{jpList[key]}}<span class="m-form__label--necessary">※必須</span>
            <select class="m-form__input m-form__input--select" name="category" v-model="list[key]" >
            <option value="" disabled>--選択してください--</option>
              <option v-for="val in dayOfWeekList" v-bind:value="val">{{ jpList[val] }}</option>
            </select></span>
         </label>
         <label class="m-form__label m-form__item--100" v-if="list.type=='frequency' && key=='minuteThreshold'">
           {{jpList[key]}}<span class="m-form__label--necessary">※必須</span>
         <select class="m-form__input m-form__input--select" name="category" v-model="list[key]" >
         <option value="" disabled>--選択してください--</option>
           <option v-for="val in minuteList" v-bind:value="val">{{ val }}</option>
         </select></span>
         </label>
         <label class="m-form__label m-form__item--100" v-if="list.type=='frequency' && key=='dayThreshold' && list.periodType == 'month'">
           {{jpList[key]}}<span class="m-form__label--necessary">※必須</span>
         <select class="m-form__input m-form__input--select" name="category" v-model="list[key]" >
         <option value="" disabled>--選択してください--</option>
           <option v-for="val in dayList" v-bind:value="val">{{ val }}</option>
         </select></span>
         </label>
         <label class="m-form__label m-form__item--100" v-if="list.type=='frequency' && key=='hourThreshold' && (list.periodType == 'day' || list.periodType == 'month' || list.periodType == 'week')">
           {{jpList[key]}}<span class="m-form__label--necessary">※必須</span>
         <select class="m-form__input m-form__input--select" name="category" v-model="list[key]" >
         <option value="" disabled>--選択してください--</option>
           <option v-for="val in hourList" v-bind:value="val">{{ val }}</option>
         </select></span>
         </label>


         <label
          class="m-form__label m-form__item--100"
          v-if="key!='type' && (key=='start' || key=='end') && list.type!='day-period'"
         >{{jpList[key]}}<span class="m-form__label--necessary">※必須</span>
           <input
            class="m-form__input m-form__input--text"
            type="time"
            v-model=list[key]
           >
         </label>
         <label
          class="m-form__label m-form__item--100"
          v-if="key!='type' && (key=='start' || key=='end') && list.type=='day-period'"
         >{{jpList[key]}}<span class="m-form__label--necessary">※必須</span>
           <input
            class="m-form__input m-form__input--text"
            type="datetime-local"
            v-model=list[key]
           >
         </label>
       </div>
       <button class="m-form__delete" v-on:click="deleteRule(list)">delete</button>
     </div>
    </div>
    <div class="m-form__item-wrapper">
      <h2 class="a-title a-title--sub m-form__item--25" >右タブからルールを追加できます</h2>
      <div class="m-form__item m-form__item--30">
        <select class="m-form__input m-form__input--select m-form__item--20" name="category" v-model="selectCategory" @change="selectRuleCategory(selectCategory)">
          <option value="" disabled>--選択してください--</option>
          <option v-for="(val, key) in categoryList" v-bind:value="key">{{ val }}</option>
        </select>
      </div>
      <div class="m-form__item m-form__item--30">
        <select class="m-form__input m-form__input--select m-form__item--20" name="category" v-model="addRule" @change="addRuleThing(addRule)">
          <option value="" disabled>--選択してください--</option>
          <option v-for="(val, key) in selectRuleList" v-bind:value="key">{{ val }}</option>
        </select>
      </div>
    </div>
     <br/><hr/><br/>
     <p class="a-button__wrapper">
       <button class="a-button" v-on:click="updateFrame">更新</button>
       <button class="a-button a-button--cansel" v-on:click="goGetFrame">枠詳細画面に戻る</button>
     </p>
   </main>
  </div>
</template>

<script>
import store from '../../../stores'
import { pageMode, regexp, pageNgRegexp, ruleList, ruleFormatList, categoryList, categoryRuleList, operatorList, strOperatorList, jpList, scopeList, numberRegexp, weekList, rulememoList, timezoneList, periodTypeList, dayOfWeekList, dayList, hourList, minuteList } from '../../../constants'
import { includes, uniqBy, cloneDeep } from 'lodash'

export default {
  name: 'updateFrame',
  data() {
    return {
      updateFrameTitle: '枠編集',
      pageMode,
      ruleList,
      categoryList,
      selectCategory: '',
      rulememoList,
      operatorList,
      strOperatorList,
      jpList,
      scopeList,
      weekList,
      addRule: '',
      addAction: '',
      selectRuleList: [],
      categoryRuleList,
      timezoneList,
      periodTypeList,
      dayOfWeekList,
      dayList,
      hourList,
      minuteList
    }
  },
  created() {
    store.dispatch('checkSessionId')
    store.dispatch('getSegmentList', this.segmentList)
    store.dispatch('getFrameData', { fqdn: this.$route.query.fqdn, frameId: this.$route.query.frameId })
    store.dispatch('getActionList', this.actionType)
  },
  computed: {
    tasks: { get() { return store.state.frame.frame } },
    actionNames: {
      get() {
        let actionNames = {}
        let actionList = store.state.frame.actionList
        for (let i = 0; i < actionList.length; i++) {
          actionNames[actionList[i].actionId] = actionList[i].metadata.name
        }
        return actionNames
      }
    },
    actionList: { get() { return store.state.frame.actionList } },
    nonRatio: { get() { return store.state.frame.nonRatio } },
    actionType: { get() { return store.state.frame.actionType } },
    segmentList: { get() { return store.state.frame.segmentList } },
    // バリデーション関数を定義する
    upValidation: function () {
      return {
        fqdn: regexp.test(this.tasks.fqdn), // fqdn
        frameId: regexp.test(this.tasks.frameId), // frameId
        name: !!this.tasks.metadata.name.trim(), // name
        pages: this.checkPages, // pages
        actions: this.checkActions, // actions
        segments: this.checkSegments, // segments
        rules: this.checkRules // rules
      }
    },
    // バリデーションを読み込む関数
    isUpValid: function () {
      let msg = []
      if (this.tasks.frameId == null || this.tasks.frameId === '') {
        msg.push('frameIdは必須です')
      } else if (this.upValidation.frameId === false) {
        msg.push('入力項目(frameId)に不備があります')
      }
      if (this.upValidation.name === false) {
        msg.push('タイトルは必須です')
      }
      msg = msg.concat(this.upValidation.pages)
      msg = msg.concat(this.upValidation.actions)
      msg = msg.concat(this.upValidation.rules)
      return msg.join('\n')
    },
    // ページ入力のバリデーション
    checkPages: function () {
      let pagesMsg = []
      for (let i = 0; i < this.tasks.configuration.pages.length; i++) {
        // 空白チェック
        if (this.tasks.configuration.pages[i].pattern === '') {
          pagesMsg.push('表示（非表示）ページ[' + (i + 1) + ']:ドメイン下のパスは必須です')
        } else if (pageNgRegexp.test(this.tasks.configuration.pages[i].pattern) === true) {
          pagesMsg.push('表示（非表示）ページ[' + (i + 1) + ']:ドメイン下のパスに不備があります')
        }
        if (this.tasks.configuration.pages[i].mode === '') {
          pagesMsg.push('表示（非表示）ページ[' + (i + 1) + ']:modeは必須です')
        }
        // TODO:被りはバリデーションにないが、可能なら今後チェックにつける
      }
      return pagesMsg
    },
    // アクション入力のバリデーション
    checkActions: function () {
      let ratioSum = Number(this.nonRatio)
      let actionMsg = []

      // 重複チェック
      var noDuplicate = uniqBy(this.tasks.configuration.actions, 'actionId')
      if (this.tasks.configuration.actions.length !== noDuplicate.length) {
        actionMsg.push('アクションが重複しています')
      }

      for (let i = 0; i < this.tasks.configuration.actions.length; i++) {
        // 空白チェック
        if (this.tasks.configuration.actions[i].ratio === '') {
          actionMsg.push('アクション[' + (i + 1) + ']:出現率は必須です')
        } else if (this.tasks.configuration.actions[i].ratio < 1 || this.tasks.configuration.actions[i].ratio > 100) {
          actionMsg.push('アクション[' + (i + 1) + ']:出現率に不備があります(1~100)')
        }
        ratioSum = ratioSum + Number(this.tasks.configuration.actions[i].ratio)
        // TODO:被りとアクションTypeの一致判定はバリデーションにないが、可能なら今後チェックにつける
      }
      // 比率の合計は1になっていること
      if (ratioSum !== 100) {
        actionMsg.push('比率の合計は100になっていません')
      }
      return actionMsg
    },
    checkSegments: function () {
      let segmentMsg = []
      if (this.tasks.configuration.segments.length > 1) {
        segmentMsg.push('セグメントの複数指定は対応していません')
      }
      return segmentMsg
    },
    // ルール入力のバリデーション
    checkRules: function (rule) {
      let ruleMsg = []
      for (let i = 0; i < this.tasks.configuration.rules.length; i++) {
        // パターン別にバリデーションをかける
        switch (this.tasks.configuration.rules[i].type) {
          case 'visit-count':
            if (numberRegexp.test(this.tasks.configuration.rules[i].count) === false) {
              ruleMsg.push('入力項目(訪問回数:count)に不備があります')
            }
            if (!includes(operatorList, this.tasks.configuration.rules[i].operator)) {
              ruleMsg.push('入力項目(訪問回数:operator)に不備があります')
            }
            break
          case 'last-page-view':
            if (!!this.tasks.configuration.rules[i].threashold.trim() === false) {
              ruleMsg.push('最後のページビュー日時:threasholdは必須です')
            }
            if (!includes(operatorList, this.tasks.configuration.rules[i].operator)) {
              ruleMsg.push('入力項目(最後のページビュー日時:operator)に不備があります')
            }
            break
          case 'page-view-count':
            if (!includes(scopeList, this.tasks.configuration.rules[i].scope)) {
              ruleMsg.push('入力項目(ページビュー数:scope)に不備があります')
            }
            if (numberRegexp.test(this.tasks.configuration.rules[i].count) === false) {
              ruleMsg.push('入力項目(ページビュー数:count)に不備があります')
            }
            if (!includes(operatorList, this.tasks.configuration.rules[i].operator)) {
              ruleMsg.push('入力項目(ページビュー数:operator)に不備があります')
            }
            break
          case 'stay-seconds':
            if (!includes(scopeList, this.tasks.configuration.rules[i].scope)) {
              ruleMsg.push('入力項目(滞在秒数:scope)に不備があります')
            }
            if (numberRegexp.test(this.tasks.configuration.rules[i].seconds) === false) {
              ruleMsg.push('入力項目(滞在秒数:seconds)に不備があります')
            }
            if (!includes(operatorList, this.tasks.configuration.rules[i].operator)) {
              ruleMsg.push('入力項目(滞在秒数:operator)に不備があります')
            }
            break
          case 'view-page-path':
            if (!includes(scopeList, this.tasks.configuration.rules[i].scope)) {
              ruleMsg.push('入力項目(閲覧ページのパス:scope)に不備があります')
            }
            if (!!this.tasks.configuration.rules[i].page.trim() === false) {
              ruleMsg.push('閲覧ページのパス:pageは必須です')
            }
            if (numberRegexp.test(this.tasks.configuration.rules[i].count) === false) {
              ruleMsg.push('入力項目(閲覧ページのパス:count)に不備があります')
            }
            if (!includes(operatorList, this.tasks.configuration.rules[i].operator)) {
              ruleMsg.push('入力項目(閲覧ページのパス:operator)に不備があります')
            }
            break
          case 'last-page-path':
            if (!!this.tasks.configuration.rules[i].page.trim() === false) {
              ruleMsg.push('最後の閲覧ページのパス:pageは必須です')
            }
            if (!includes(operatorList, this.tasks.configuration.rules[i].operator)) {
              ruleMsg.push('入力項目(最後の閲覧ページのパス:operator)に不備があります')
            }
            break
          case 'walk-3pages':
            if (!!this.tasks.configuration.rules[i].page1.trim() === false) {
              ruleMsg.push('3階層ページ遷移閲覧シナリオ:page1は必須です')
            }
            if (!!this.tasks.configuration.rules[i].page2.trim() === false) {
              ruleMsg.push('3階層ページ遷移閲覧シナリオ:page2は必須です')
            }
            if (!!this.tasks.configuration.rules[i].page3.trim() === false) {
              ruleMsg.push('3階層ページ遷移閲覧シナリオ:page3は必須です')
            }
            break
          case 'referer':
            if (!!this.tasks.configuration.rules[i].page.trim() === false) {
              ruleMsg.push('リンク元ページ（リファラ）のホスト:pageは必須です')
            }
            if (!includes(operatorList, this.tasks.configuration.rules[i].operator)) {
              ruleMsg.push('入力項目(リンク元ページ（リファラ）のホスト:operator)に不備があります')
            }
            break
          case 'utm-source':
            if (!!this.tasks.configuration.rules[i].value.trim() === false) {
              ruleMsg.push('閲覧ページのクエリキー（utm_source）:valueは必須です')
            }
            if (!includes(operatorList, this.tasks.configuration.rules[i].operator)) {
              ruleMsg.push('入力項目(閲覧ページのクエリキー（utm_source）:operator)に不備があります')
            }
            break
          case 'src-link-path':
            if (!!this.tasks.configuration.rules[i].link.trim() === false) {
              ruleMsg.push('サイト内のリンク元ページのパス:linkは必須です')
            }
            if (!includes(operatorList, this.tasks.configuration.rules[i].operator)) {
              ruleMsg.push('入力項目(サイト内のリンク元ページのパス:operator)に不備があります')
            }
            break
          case 'user-os':
            if (!!this.tasks.configuration.rules[i].value.trim() === false) {
              ruleMsg.push('アクセス時のOS名:valueは必須です')
            }
            if (!includes(operatorList, this.tasks.configuration.rules[i].operator)) {
              ruleMsg.push('入力項目(アクセス時のOS名:operator)に不備があります')
            }
            break
          case 'stop-view-count':
            if (!includes(scopeList, this.tasks.configuration.rules[i].scope)) {
              ruleMsg.push('入力項目(配信回数上限で配信を停止:scope)に不備があります')
            }
            if (numberRegexp.test(this.tasks.configuration.rules[i].count) === false) {
              ruleMsg.push('入力項目(配信回数上限で配信を停止:count)に不備があります')
            }
            break
          case 'stop-close-count':
            if (!includes(scopeList, this.tasks.configuration.rules[i].scope)) {
              ruleMsg.push('入力項目(閉じられた回数で配信を停止:scope)に不備があります')
            }
            if (numberRegexp.test(this.tasks.configuration.rules[i].count) === false) {
              ruleMsg.push('入力項目(閉じられた回数で配信を停止:count)に不備があります')
            }
            break
          case 'stop-click-count':
            if (!includes(scopeList, this.tasks.configuration.rules[i].scope)) {
              ruleMsg.push('入力項目(クリック回数で配信を停止:scope)に不備があります')
            }
            if (numberRegexp.test(this.tasks.configuration.rules[i].count) === false) {
              ruleMsg.push('入力項目(クリック回数で配信を停止:count)に不備があります')
            }
            break
          case 'day-period':
            if (!!this.tasks.configuration.rules[i].start.trim() === false) {
              ruleMsg.push('期間:startは必須です')
            }
            if (!!this.tasks.configuration.rules[i].end.trim() === false) {
              ruleMsg.push('期間:endは必須です')
            }
            if (!!this.tasks.configuration.rules[i].timezone.trim() === false) {
              ruleMsg.push('期間:timezoneは必須です')
            }
            break
          case 'day-of-week':
            let weekFlg = true
            if (!Array.isArray(this.tasks.configuration.rules[i].values)) {
              this.tasks.configuration.rules[i].values = this.tasks.configuration.rules[i].values.split(',')
            }
            for (let t = 0; t < this.tasks.configuration.rules[i].values.length; t++) {
              if (!includes(weekList, this.tasks.configuration.rules[i].values[t])) {
                weekFlg = false
              }
            }
            if (!weekFlg) {
              ruleMsg.push('入力項目(曜日:value)に不備があります')
            }
            if (!!this.tasks.configuration.rules[i].timezone.trim() === false) {
              ruleMsg.push('曜日:timezoneは必須です')
            }
            break
          case 'day-time':
            if (!!this.tasks.configuration.rules[i].start.trim() === false) {
              ruleMsg.push('時間:startは必須です')
            }
            if (!!this.tasks.configuration.rules[i].end.trim() === false) {
              ruleMsg.push('時間:endは必須です')
            }
            if (!!this.tasks.configuration.rules[i].timezone.trim() === false) {
              ruleMsg.push('時間:timezoneは必須です')
            }
            break
          case 'frequency':
            if (!includes(periodTypeList, this.tasks.configuration.rules[i].periodType)) {
              ruleMsg.push('頻度:periodTypeは必須です')
            }
            if (!!this.tasks.configuration.rules[i].timezone.trim() === false) {
              ruleMsg.push('頻度:timezoneは必須です')
            }
            if (numberRegexp.test(this.tasks.configuration.rules[i].interval) === false) {
              ruleMsg.push('頻度:intervalは必須です')
            }
            if (!includes(minuteList, this.tasks.configuration.rules[i].minuteThreshold)) {
              ruleMsg.push('頻度:minuteThresholdは必須です')
            }
            if (!includes(hourList, this.tasks.configuration.rules[i].hourThreshold) && (this.tasks.configuration.rules[i].periodType === 'week' || this.tasks.configuration.rules[i].periodType === 'month' || this.tasks.configuration.rules[i].periodType === 'day')) {
              ruleMsg.push('頻度:hourThresholdは必須です')
            }
            if (!includes(dayOfWeekList, this.tasks.configuration.rules[i].dayOfWeekThreshold) && this.tasks.configuration.rules[i].periodType === 'week') {
              ruleMsg.push('頻度:dayOfWeekThresholdは必須です')
            }
            if (!includes(dayList, this.tasks.configuration.rules[i].dayThreshold) && this.tasks.configuration.rules[i].periodType === 'month') {
              ruleMsg.push('頻度:dayThresholdは必須です')
            }
            break
          case 'user-view-limit':
            if (!includes(scopeList, this.tasks.configuration.rules[i].scope)) {
              ruleMsg.push('配信数上限:scopeに不備があります')
            }
            if (numberRegexp.test(this.tasks.configuration.rules[i].count) === false) {
              ruleMsg.push('配信数上限:countに不備があります')
            }
            break
          case 'unknow':
            break
        }
      }
      return ruleMsg
    }
  },

  methods: {
    callFrame: function() { store.dispatch('frame', this.tasks) },
    updateFrame: function() {
      var errMsg = this.isUpValid
      if (errMsg === '') {
        store.dispatch('checkSessionId')
        store.dispatch('updateFrame', this.$router)
      } else {
        alert(errMsg)
      }
    },
    // 編集対象の枠を呼び出す
    goGetFrame: function() {
      this.$router.push('/delivery/get-frame?frameId=' + this.$route.query.frameId + '&fqdn=' + this.$route.query.fqdn)
    },
    // ページリストから選択したページを削除する
    deletePage: function(list) {
      this.tasks.configuration.pages.splice(this.tasks.configuration.pages.indexOf(list), 1)
    },
    // アクションリストから選択したアクションを削除する
    deleteAction: function(list) {
      this.tasks.configuration.actions.splice(this.tasks.configuration.actions.indexOf(list), 1)
      store.dispatch('ratioChange')
    },
    // セグメントリストから選択したセグメントを削除する
    deleteSegment: function(list) {
      this.tasks.configuration.segments.splice(this.tasks.configuration.segments.indexOf(list), 1)
      this.segment = ''
    },
    // ルールリストから選択したルールを削除する
    deleteRule: function(list) {
      this.tasks.configuration.rules.splice(this.tasks.configuration.rules.indexOf(list), 1)
    },
    // ページを追加する
    createPage: function() {
      this.tasks.configuration.pages.push({ pattern: '', mode: '' })
    },
    // アクションを追加する
    addActionThing: function(addAction) {
      var actionIds = this.tasks.configuration.actions.map(function(value) {
        return value.actionId
      })
      if (actionIds.length > 0 && actionIds.indexOf(addAction) >= 0) {
        alert(this.actionNames[addAction] + 'は存在します')
      } else {
        this.tasks.configuration.actions.push({ actionId: addAction, ratio: '' })
      }
      this.addAction = ''
    },
    // セグメントを追加する
    addSegmentThing: function(addSegment) {
      this.tasks.configuration.segments.push({ segmentId: addSegment })
    },
    // アクション種別を変更したら追加可能なアクションリストを更新する
    selectActionType: function(actionType) {
      store.dispatch('getActionList', actionType)
      this.addAction = ''
    },
    // ルールを追加する
    addRuleThing: function(addRule) {
      this.tasks.configuration.rules.push(cloneDeep(ruleFormatList[addRule]))
      this.addRule = ''
      this.selectRuleList = ''
      this.selectCategory = ''
    },
    ratioChange: function() {
      store.dispatch('ratioChange')
    },
    selectRuleCategory: function(selectCategory) {
      this.selectRuleList = categoryRuleList[selectCategory]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/delivery/frame/UpdateFrame.vue